import { createRouter, createWebHistory } from 'vue-router'
import { useAuthStore } from '@/store/auth'

import LoginView from '../views/LoginView.vue'
import HomeView from '../views/HomeView.vue'
import ProvidersView  from "@/views/ProvidersView.vue";
import ExportsView from "@/views/ExportsView.vue";
import ProviderDetailView from "@/views/ProviderDetailView.vue";
import ExportsDetailView from "@/views/ExportsDetailView.vue";
import OrdersView from "@/views/OrdersView.vue";
import OrdersDetailView from "@/views/OrdersDetailView.vue";
import CustomersView from "@/views/CustomersView.vue";
import CustomersDetailView from "@/views/CustomersDetailView.vue";
import ProvidersImportView from "@/views/ProvidersImportView.vue";
import CategoriesImportView from "@/views/CategoriesImportView.vue";
import ProductsImportView from "@/views/ProductsImportView.vue";
import CatalogWorkspace from '@/features/catalog/CatalogWorkspace.vue'
import ProductsListView from '@/features/catalog/products/ProductsListView.vue'
import ProductFormView from '@/features/catalog/products/ProductFormView.vue'
import CategoriesListView from '@/features/catalog/categories/CategoriesListView.vue'
import CategoryFormView from '@/features/catalog/categories/CategoryFormView.vue'
import BrandsListView from '@/features/catalog/brands/BrandsListView.vue'
import BrandFormView from '@/features/catalog/brands/BrandFormView.vue'
import CharacteristicsListView from '@/features/catalog/characteristics/CharacteristicsListView.vue'
import CharacteristicFormView from '@/features/catalog/characteristics/CharacteristicFormView.vue'

const routes = [
  {
    path: '/login',
    name: 'Login',
    component: LoginView
  },
  {
    path: '/',
    name: 'home',
    component: HomeView,
    meta: { requiresAuth: true, showInMenu: true, title: "Головна", icon:"bi-house" }
  },
  {
    path: '/providers',
    name: 'providers',
    component: ProvidersView,
    meta: {
      requiresAuth: true,
      showInMenu: true,
      title: "Постачальники",
      icon:"bi-truck",
      breadcrumb: [{name:'home', title:'Головна'}]
    }
  },
  {
    path: '/providers/import',
    name: 'providersImport',
    component: ProvidersImportView,
    meta: {
      requiresAuth: true,
      title: "Імпорт",
      icon:"bi-truck",
      breadcrumb: [{name:'home', title:'Головна'},{name:'providers', title:'Постачальники'}]
    }
  },
  {
    path: '/providers/:id',
    name: 'providersDetail',
    component: ProviderDetailView,
    meta: {
      requiresAuth: true,
      title: "Редагувати",
      breadcrumb: [{name:'home', title:'Головна'},{name:'providers', title:'Постачальники'}]
    }
  },
  {
    path: '/catalog',
    name: 'catalog',
    component: CatalogWorkspace,
    redirect: { name: 'catalogProducts' },
    meta: { requiresAuth: true, showInMenu: true, title: 'Каталог', icon: 'bi-shop', breadcrumb: [{ name: 'home', title: 'Головна' }] },
    children: [
      { path: 'products', name: 'catalogProducts', component: ProductsListView, meta: { title: 'Товари', breadcrumb: [{ name: 'home', title: 'Головна' }, { name: 'catalogProducts', title: 'Каталог' }] } },
      { path: 'products/import', name: 'catalogProductsImport', component: ProductsImportView, meta: { title: 'Імпорт товарів', breadcrumb: [{ name: 'home', title: 'Головна' }, { name: 'catalogProducts', title: 'Каталог' }] } },
      { path: 'products/:id', name: 'catalogProductForm', component: ProductFormView, meta: { title: 'Товар', breadcrumb: [{ name: 'home', title: 'Головна' }, { name: 'catalogProducts', title: 'Товари' }] } },
      { path: 'categories', name: 'catalogCategories', component: CategoriesListView, meta: { title: 'Категорії', breadcrumb: [{ name: 'home', title: 'Головна' }, { name: 'catalogProducts', title: 'Каталог' }] } },
      { path: 'categories/import', name: 'catalogCategoriesImport', component: CategoriesImportView, meta: { title: 'Імпорт категорій', breadcrumb: [{ name: 'home', title: 'Головна' }, { name: 'catalogCategories', title: 'Категорії' }] } },
      { path: 'categories/:id', name: 'catalogCategoryForm', component: CategoryFormView, meta: { title: 'Категорія', breadcrumb: [{ name: 'home', title: 'Головна' }, { name: 'catalogCategories', title: 'Категорії' }] } },
      { path: 'brands', name: 'catalogBrands', component: BrandsListView, meta: { title: 'Бренди', breadcrumb: [{ name: 'home', title: 'Головна' }, { name: 'catalogProducts', title: 'Каталог' }] } },
      { path: 'brands/:id', name: 'catalogBrandForm', component: BrandFormView, meta: { title: 'Бренд', breadcrumb: [{ name: 'home', title: 'Головна' }, { name: 'catalogBrands', title: 'Бренди' }] } },
      { path: 'characteristics', name: 'catalogCharacteristics', component: CharacteristicsListView, meta: { title: 'Характеристики', breadcrumb: [{ name: 'home', title: 'Головна' }, { name: 'catalogProducts', title: 'Каталог' }] } },
      { path: 'characteristics/:id', name: 'catalogCharacteristicForm', component: CharacteristicFormView, meta: { title: 'Характеристика', breadcrumb: [{ name: 'home', title: 'Головна' }, { name: 'catalogCharacteristics', title: 'Характеристики' }] } },
    ],
  },
  { path: '/products', name: 'ProductsView', redirect: { name: 'catalogProducts' } },
  { path: '/products/import', name: 'ProductsImport', redirect: { name: 'catalogProductsImport' } },
  { path: '/products/:id', name: 'productsDetail', redirect: (to) => ({ name: 'catalogProductForm', params: { id: to.params.id } }) },
  { path: '/categories', name: 'CategoriesView', redirect: { name: 'catalogCategories' } },
  { path: '/categories/import', name: 'categoriesImport', redirect: { name: 'catalogCategoriesImport' } },
  { path: '/categories/:id', name: 'categoriesDetail', redirect: (to) => ({ name: 'catalogCategoryForm', params: { id: to.params.id } }) },
  {
    path: '/exports',
    name: 'ExportsView',
    component: ExportsView,
    meta: {
      requiresAuth: true,
      showInMenu: true,
      title: "Вигрузки",
      icon:"bi-cloud-download",
      breadcrumb: [{name:'home', title:'Головна'}]
    }
  },
  {
    path: '/exports/:id',
    name: 'exportsDetail',
    component: ExportsDetailView,
    meta: {
      requiresAuth: true,
      title: "Редагувати",
      breadcrumb: [
        {name:'home', title:'Головна'},
        { name:'ExportsView', title:'Вигрузки'}
      ]
    }
  },
  {
    path: '/orders',
    name: 'OrdersView',
    component: OrdersView,
    meta: {
      requiresAuth: true,
      showInMenu: true,
      title: "Замовлення",
      icon:"bi-cart",
      breadcrumb: [
        {name:'home', title:'Головна'}
      ]
    }
  },
  {
    path: '/orders/:id',
    name: 'OrdersDetail',
    component: OrdersDetailView,
    meta: {
      requiresAuth: true,
      title: "Редагувати",
      breadcrumb: [
        {name:'home', title:'Головна'},
        {name:'OrdersView', title:'Замовлення'}
      ]
    }
  },
  {
    path: '/customers',
    name: 'CustomersView',
    component: CustomersView,
    meta: {
      requiresAuth: true,
      showInMenu: true,
      title: "Клієнти",
      icon:"bi-people",
      breadcrumb: [
        {name:'home', title:'Головна'}
      ]
    }
  },
  {
    path: '/customers/:id',
    name: 'CustomersDetail',
    component: CustomersDetailView,
    meta: {
      requiresAuth: true,
      title: "Редагувати",
      breadcrumb: [
        {name:'home', title:'Головна'},
        {name:'CustomersView', title:'Клієнти'}
      ]
    }
  },
  {
    path: '/logout',
    name: 'logout',
    beforeEnter: (to, from, next) => {
      const auth = useAuthStore()
      auth.logout()
      next('/login');
    },
    meta: { requiresAuth: true, showInMenu: true, title: "Вихід", icon:"bi-box-arrow-right" }
  }
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

router.beforeEach(async (to) => {
  const auth = useAuthStore()

  if (to.name === 'Login') {
    if (!auth.token) {
      return true
    }
    const isValid = await auth.checkToken()
    if (isValid) {
      const redirect = typeof to.query.redirect === 'string' ? to.query.redirect : '/'
      if (redirect.startsWith('/') && redirect !== '/login') {
        return { path: redirect }
      }
      return { path: '/' }
    }
    return true
  }

  if (!to.meta.requiresAuth) {
    return true
  }

  if (!auth.token) {
    return { name: 'Login', query: { redirect: to.fullPath } }
  }

  const isValid = await auth.checkToken()
  if (!isValid) {
    return { name: 'Login', query: { redirect: to.fullPath } }
  }

  return true
})

export default router
